var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Button, GBTypography } from '@leapfinance/geebee-component-library';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import { Divider } from '@mui/material';
import { isFalsy } from '../../../utils/common';
import { copyDetails } from '../../geebee/cf/CfCourseCardUtil';
import CFCourseUtil from '../../geebee/cf/CFCourseUtil';
import CoursesDownloadButtonSection from './CoursesDownloadButtonSection';
var CourseDetail = function (_a) {
    var title = _a.title, value = _a.value;
    return (React.createElement("div", { className: "lfc-flex lfc-flex-col" },
        React.createElement(GBTypography, { variant: "caption2", className: "lfc-text-grey-700" }, title),
        React.createElement(GBTypography, { variant: "caption1", className: "lfc-text-grey-900 lfc-font-bold" }, value)));
};
var SimilarCourseCard = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var course = _a.course, onCourseShortlist = _a.onCourseShortlist, onCsvDownload = _a.onCsvDownload, onPdfDownload = _a.onPdfDownload, partnerName = _a.partnerName, primaryCtaProps = _a.primaryCtaProps, onCustomCopyClick = _a.onCustomCopyClick;
    var courseInstance = new CFCourseUtil(course);
    var _h = __read(useState(false), 2), isActive = _h[0], setIsActive = _h[1];
    var onImageError = function (e) {
        e.target.src = '/assets/icons/course-finder/university-icon.svg';
    };
    return (React.createElement("div", { className: "lfc-p-3 lfc-rounded-lg lfc-bg-accentGrey-200" },
        React.createElement("div", { className: "lfc-flex lfc-flex-row lfc-items-center lfc-gap-2 lfc-pb-2" },
            React.createElement("div", { className: "lfc-w-10 lfc-h-10" },
                React.createElement("img", { src: (_b = course.imageUrl) !== null && _b !== void 0 ? _b : '/assets/icons/course-finder/university-icon.svg', alt: "uni", className: "lfc-w-10 lfc-h-10", onError: onImageError })),
            React.createElement("div", { className: "lfc-flex lfc-flex-col" },
                React.createElement(GBTypography, { variant: "sh3", className: "lfc-text-primary-700", role: "button", onClick: function () {
                        window.open("/course-details/".concat(course.courseId), '_blank', 'noopener');
                    } }, course.courseName),
                React.createElement("div", { className: "lfc-flex lfc-items-center" },
                    React.createElement(GBTypography, { variant: "caption1", className: "lfc-text-[#4A4A4A]" }, course.universityName),
                    (course === null || course === void 0 ? void 0 : course.cityName) || (course === null || course === void 0 ? void 0 : course.countryName) ? (React.createElement("div", { className: "lfc-flex lfc-items-center lfc-gap-x-1" },
                        React.createElement(LocationOnRoundedIcon, { className: "lfc-text-base lfc-text-grey-500" }),
                        React.createElement(GBTypography, { variant: "caption1", className: "lfc-text-[#4A4A4A]" }, (_c = [course === null || course === void 0 ? void 0 : course.cityName, course === null || course === void 0 ? void 0 : course.countryName]) === null || _c === void 0 ? void 0 : _c.join(', ')))) : null))),
        React.createElement(Divider, null),
        React.createElement("div", { className: "lfc-grid lfc-grid-cols-2 lg:lfc-grid-cols-4 lfc-py-2 lfc-gap-2" }, [
            {
                title: 'Application Fee',
                value: "".concat(courseInstance.getApplicationFeeLabel())
            },
            {
                title: "".concat(courseInstance.getTutionFeeTitle()),
                value: "".concat(courseInstance.getTutionFeeLabel())
            },
            {
                title: 'Duration',
                value: "".concat(courseInstance.getDurationLabel())
            },
            {
                title: 'College Rank',
                value: isFalsy((_d = courseInstance.course) === null || _d === void 0 ? void 0 : _d.rank) ? '-' : "".concat((_e = courseInstance.course) === null || _e === void 0 ? void 0 : _e.rank)
            }
        ].map(function (item, index) { return (React.createElement(CourseDetail, __assign({ key: index }, item))); })),
        React.createElement(Divider, null),
        React.createElement("div", { className: "xl:lfc-hidden lfc-flex lfc-items-center lfc-gap-2 lfc-py-2" },
            React.createElement("div", { className: "lfc-w-1/3 lfc-whitespace-nowrap" },
                React.createElement(CoursesDownloadButtonSection, { courses: [course], onPdfDownload: onPdfDownload, onCsvDownload: onCsvDownload })),
            React.createElement(Button, __assign({ size: "small", fullWidth: true, color: "primary", className: "lfc-w-2/3 lfc-whitespace-nowrap", startIcon: React.createElement("i", { className: "fi fi-sr-plus lfc-text-[12px]" }) }, primaryCtaProps, { onClick: function () {
                    onCourseShortlist(course);
                }, variant: "primary" }),
                React.createElement("div", { className: "lfc-flex lfc-items-start lfc-flex-row lfc-gap-x-1" },
                    React.createElement(GBTypography, { variant: "cta5", className: "lfc-text-white lfc-normal-case" }, (_f = primaryCtaProps === null || primaryCtaProps === void 0 ? void 0 : primaryCtaProps.labelText) !== null && _f !== void 0 ? _f : 'Add to Shortlist')))),
        React.createElement("div", { className: "lfc-hidden xl:lfc-flex lfc-items-center lfc-justify-between lfc-py-2 lfc-gap-y-2" },
            React.createElement(Button, { size: "small", onClick: function () {
                    onCustomCopyClick === null || onCustomCopyClick === void 0 ? void 0 : onCustomCopyClick(course);
                    copyDetails(setIsActive, { partnerName: partnerName }, course);
                }, startIcon: React.createElement("i", { className: "fi fi-rr-clone lfc-text-sm ".concat(isActive ? 'lfc-text-white' : 'lfc-text-black') }), variant: isActive ? 'primary' : 'tertiary', className: "".concat(isActive ? 'lfc-bg-success-500' : '') },
                React.createElement(GBTypography, { variant: "link3", className: "lfc-whitespace-nowrap ".concat(isActive ? 'lfc-text-white lfc-no-underline' : 'lfc-text-black', " lfc-transition-colors lfc-normal-case") }, isActive ? 'Details Copied' : 'Copy Details')),
            React.createElement("div", { className: "lfc-flex lfc-items-center lfc-gap-2 lfc-flex-4" },
                React.createElement(CoursesDownloadButtonSection, { courses: [course], onPdfDownload: onPdfDownload, onCsvDownload: onCsvDownload }),
                React.createElement(Button, __assign({ size: "small", color: "primary", className: "lfc-read-only-cta lfc-w-full lfc-min-w-fit", startIcon: React.createElement("i", { className: "fi fi-sr-plus lfc-text-[12px]" }) }, primaryCtaProps, { variant: "primary", onClick: function () {
                        onCourseShortlist(course);
                    } }),
                    React.createElement("div", { className: "lfc-flex lfc-items-start lfc-flex-row lfc-gap-x-1" },
                        React.createElement(GBTypography, { variant: "cta5", className: "lfc-text-white lfc-normal-case" }, (_g = primaryCtaProps === null || primaryCtaProps === void 0 ? void 0 : primaryCtaProps.labelText) !== null && _g !== void 0 ? _g : 'Add to Shortlist')))))));
};
export default SimilarCourseCard;
//# sourceMappingURL=SimilarCourseCard.js.map